import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { WebRequestService } from 'src/app/services/web-request.service';
import { LoaderComponent } from '../../builders/loader/loader.component';
import { Data } from 'src/app/helper/datastore';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  LoaderComponent: any;
  loginData:any;
  showNotification: Number;
  noServiceListRm2All:any;
  loadAllLoggedData:boolean;
  unpaidReqData:any;
  notificationReqData:any;
  allLoggedUsers: any[] = [];
  loadAllData:any;
  loadAllNotificationData:boolean;
  // unpaidReqData:any;
  allNotificationUsers: any[] = [];
  loadAllNotifications:any;

  constructor(public router: Router,
    public auth: AuthService,
    public messagingService: MessagingService,
    public service: WebRequestService,
    private data: Data,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private modalData: any,
    public dialogRef: MatDialogRef<NotificationComponent>) { }


  notificationData:any;
  ngOnInit(): void {


    this.data.getStoreData('empData')
    .then((dataRes: any) => {
      this.loginData = JSON.parse(dataRes);
      // if (this.loginData) {
      //   this.LoaderComponent = LoaderComponent;
      //   this.service.getPagePermissionsData(this.loginData['employeeID']).then((res) => {
      //     if (res['statusCode'] === 200) {
      //       this.LoaderComponent = '';
      //       this.employeePagePermission = res['result']['employeeAllowedPages'];
      //       this.getEmployeeNotification(this.loginData['employeeID'])
      //     }
      //   })
      //   .catch((err) => {
      //     this.LoaderComponent = '';
      //     console.error(err)});
      // }
    })
    .catch((err) => console.error(err));
    console.log(this.modalData.notificationData)
    this.notificationData = this.modalData.notificationData;
    this.allNotificationUsers = this.modalData.notificationData;
    this.showNotification = this.modalData.type
    this.allLoggedUsers = this.modalData.allData;
    this.loadAllData = this.modalData.allData
    this.unpaidReqData = this.modalData.reqData
    this.notificationReqData = this.modalData.notiReqData
  }

  navigateToEditviewDashboard(data){
    this.dialogRef.close();
    this.router.navigate([`/editViewDashBoard`,{id: data?.cust_ID,type:'educational'}]);

    let dataObj = {
      empID: this.loginData['employeeID'],
      displayType: 2,
      notificationID: data?.notificationID,
      categoryID: data['categoryID'],
      custID: data?.cust_ID,
      startIndex: 1,
      endIndex: 3
  }
  this.service.getEmployeeNotifications(dataObj).then((res)=>{
    console.log(res)
    // res['result'].map((val) => {
    //   this.message.push(val);
    // });
  })
  }
  getAssignTicketColour(customer) {
    if(customer['PaidStatus'] === 1){
      return 'green';
    } else if (customer['PaidStatus'] === 2) {
      return 'blue';
    } else if (customer['PaidStatus'] === 0) {
      return 'red';
    } else {
      return 'red';
    }
  }

  getProfileType(profile) {
    if (profile['ServiceType'] === 601) {
      return profile['ProfileID'] + '-  R';
    } else if(profile['ServiceType'] === 602) {
      return profile['ProfileID'] + '-  A';
    } else if(profile['ServiceType'] === 603) {
      const grade = profile['confidentialGrade'] != null ? ('- C' + profile['confidentialGrade']) : '- C';
      return profile['ProfileID'] + grade;
    }else if(profile['ServiceType'] === 604) {
      const type = (profile['SuperHighConfidential'] === 1) ? '- NX' : '- SC'
      return profile['ProfileID'] + type;
    } else if(profile['ServiceType'] === 600) {
      return profile['ProfileID'];
    } else {
      return profile['ProfileID'];
    }
  }

  loadMoreLoggedUsers() {
    if (this.unpaidReqData['endIndex'] < this.allLoggedUsers[0]['TotalRows']) {
      this.unpaidReqData['startindex'] = this.unpaidReqData['endIndex'] + 1;
      this.unpaidReqData['endIndex'] = this.unpaidReqData['endIndex'] + 10;
      this.LoaderComponent = LoaderComponent;
      this.allLoggedUsers = [];
      this.service.getEmpProfiles(this.unpaidReqData).then((res) => {
        if (res['statusCode'] === 200) {
          this.LoaderComponent = '';
          let count = res['result'].length;
          for (let i = 0; i < count; i++) {
            this.loadAllData.push(res['result'][i])
          }
          this.allLoggedUsers = this.loadAllData;
          console.log(this.allLoggedUsers)
          this.loadAllLoggedData = this.allLoggedUsers[0]['TotalRows'] === this.allLoggedUsers.length ? true : false;
        } else {
          this.LoaderComponent = '';
          // this.responseMessage = res['message'];
        }
      })
    }
  }

  loadMoreNotificationData() {
    // console.log(this.notificationReqData,  this.notificationData[0])
    if (this.notificationReqData['endIndex'] < this.notificationData[0]['notificationCount']) {
      this.notificationReqData['startindex'] = this.notificationReqData['endIndex'] + 1;
      this.notificationReqData['endIndex'] = this.notificationReqData['endIndex'] + 10;
      this.LoaderComponent = LoaderComponent;
      this.notificationData = [];
      this.service.getEmployeeNotifications(this.notificationReqData).then((res) => {
        if (res['statusCode'] === 200) {
          this.LoaderComponent = '';
          let count = res['result'].length;
          for (let i = 0; i < count; i++) {
            this.allNotificationUsers.push(res['result'][i])
          }
          this.notificationData = this.allNotificationUsers;
          // console.log(this.notificationData)
          this.loadAllNotificationData = this.notificationData[0]['notificationCount'] === this.notificationData.length ? true : false;
        } else {
          this.LoaderComponent = '';
          // this.responseMessage = res['message'];
        }
      })
    }
  }

  closeSlideShow(){
    this.dialogRef.close();
  }

}
